export default __webpack_public_path__ + "static/media/isDocUploaded.ad23a8ba.svg";